module.exports = __webpack_public_path__ + "img/target_p.b3b3a418.svg";